export default __webpack_public_path__ + "static/saas-efe9317d6a138dbe7c64bb4a34cfda7e.png";